import { Fragment, memo, ReactElement } from 'react';
import { Form, Formik } from 'formik';
import * as yup from 'yup';
import { Accordion, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { AccordionDetails } from '@mui/material';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import FormFilter from './form';
import { ResearchCommunicationFromList } from 'civil-status/view-models/communication-from-list';
import { DateTime } from 'luxon';

const validationSchema = yup.object({
  dateStart: yup.date().nullable().typeError('Data non valida'),
  dateEnd: yup
    .date()
    .nullable()
    .typeError('Data non valida')
    .when('dateStart', (dateStart, formvalidationSchema) =>
      dateStart && dateStart?.toString() !== 'Invalid Date'
        ? formvalidationSchema.min(
            dateStart,
            'La data deve essere maggiore o uguale della Data inizio'
          )
        : formvalidationSchema.nullable()
    ),
});

interface AccordionFilterProps {
  open?: boolean;
  setOpen: (value: boolean) => void;
  handleSubmitResearch: (values: ResearchCommunicationFromList) => void;
  initialValues?: ResearchCommunicationFromList;
  idCat?: string;
  scope?: string;
}

const AccordionFilterComponent = ({
  open,
  setOpen,
  handleSubmitResearch,
  initialValues,
  idCat,
  scope,
}: AccordionFilterProps): ReactElement => {
  return (
    <Fragment>
      <Formik
        key="form-filter"
        initialValues={
          initialValues ||
          ({
            code: '',
            dateEnd: DateTime.now(),
            dateStart: DateTime.now(),
            state: '',
            typeEvent: '',
            scope,
          } as ResearchCommunicationFromList)
        }
        onSubmit={(values) => handleSubmitResearch(values)}
        validateOnMount
        validationSchema={validationSchema}
      >
        <Form>
          <Accordion
            expanded={open}
            onChange={() => {
              setOpen(!open);
            }}
          >
            <AccordionSummary
              aria-controls="filter-notifications-content"
              id="panel-filter-notifications-header"
              classes={{
                root: 'pmi-flex-row-reverse',
              }}
              expandIcon={<ExpandMore />}
            >
              <Typography>Filtri di ricerca</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <FormFilter idCat={idCat} scope={scope} />
            </AccordionDetails>
          </Accordion>
        </Form>
      </Formik>
    </Fragment>
  );
};

AccordionFilterComponent.displayName =
  'Research notifications - Filters component - AccordionFilter';

const AccordionFilter = memo(AccordionFilterComponent);

export default AccordionFilter;
